<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="2" />
    <div class="mb-3">
      <h4>Atenciones por Médico</h4>
    </div>
    <hr>

    <div class="mb-3 d-flex flex-wrap gap-2">
      <button
        v-for="atajo in atajos" :key="atajo.key"
        class="btn btn-sm" :class="atajo.clase"
        @click="aplicarAtajo(atajo)"
      >{{ atajo.label }}</button>
    </div>

    <div class="input-group mb-3">
      <span class="input-group-text">Desde</span>
      <input type="date" v-model="fechaDesde" class="form-control">
      <span class="input-group-text">Hasta</span>
      <input type="date" v-model="fechaHasta" class="form-control">
      <button
        class="btn btn-dark"
        @click="generarReporte"
        :disabled="!fechaDesde || !fechaHasta || cargando"
      >
        <span v-if="cargando" class="spinner-border spinner-border-sm me-1"></span>
        Consultar
      </button>
      <button
        class="btn btn-success"
        @click="exportToCSV"
        :disabled="!atencionesPorMedico.length"
      >
        <span class="material-symbols-outlined align-middle" style="font-size:16px">download</span>
        CSV
      </button>
    </div>

    <div v-if="atencionesPorMedico.length">

      <!-- KPIs -->
      <div class="row g-3 mb-4">
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Total atenciones</div>
            <div class="kpi-value">{{ totalAtenciones.toLocaleString() }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Médicos activos</div>
            <div class="kpi-value">{{ atencionesPorMedico.length }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Promedio por médico</div>
            <div class="kpi-value">{{ promedioAtenciones }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Mayor carga</div>
            <div class="kpi-value kpi-value--sm">{{ medicoTop }}</div>
            <div class="kpi-sub">{{ maxAtenciones.toLocaleString() }} atenciones</div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="tabs">
        <button class="tablink" :class="{ 'active-tab': vistaActiva === 'tabla' }" @click="vistaActiva = 'tabla'">
          <span class="material-symbols-outlined" style="font-size:17px">table_view</span>
          Tabla
        </button>
        <button class="tablink" :class="{ 'active-tab': vistaActiva === 'grafico' }" @click="vistaActiva = 'grafico'">
          <span class="material-symbols-outlined" style="font-size:17px">bar_chart</span>
          Gráfico
        </button>
      </div>

      <!-- ── TABLA ── -->
      <div v-if="vistaActiva === 'tabla'" class="mt-3">

        <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
          <div class="input-group input-group-sm" style="max-width:300px">
            <span class="input-group-text">
              <span class="material-symbols-outlined" style="font-size:15px">search</span>
            </span>
            <input
              type="text" class="form-control"
              placeholder="Buscar médico…"
              v-model="busqueda"
              @input="paginaActual = 1"
            >
            <button v-if="busqueda" class="btn btn-outline-secondary" @click="busqueda = ''; paginaActual = 1">
              <span class="material-symbols-outlined" style="font-size:15px">close</span>
            </button>
          </div>
          <div class="d-flex align-items-center gap-2">
            <small class="text-muted">Mostrar</small>
            <select class="form-select form-select-sm" style="width:75px" v-model="filasPorPagina" @change="paginaActual = 1">
              <option :value="10">10</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
            </select>
            <small class="text-muted">filas</small>
          </div>
        </div>

        <table class="table table-bordered table-hover table-sm">
          <thead class="table-dark">
            <tr>
              <th class="sortable" @click="ordenar('nombre')">
                Médico
                <span class="material-symbols-outlined sort-icon">
                  {{ sortKey === 'nombre' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                </span>
              </th>
              <th class="text-end sortable" @click="ordenar('atenciones')">
                Atenciones
                <span class="material-symbols-outlined sort-icon">
                  {{ sortKey === 'atenciones' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                </span>
              </th>
              <th class="text-end">%</th>
              <th class="text-end">vs. promedio</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!filasPagina.length">
              <td colspan="4" class="text-center text-muted py-3">Sin resultados para "{{ busqueda }}"</td>
            </tr>
            <tr v-for="(item, index) in filasPagina" :key="index">
              <td>{{ item[0] }}</td>
              <td class="text-end">{{ item[1] }}</td>
              <td class="text-end">
                <div class="d-flex align-items-center justify-content-end gap-2">
                  <div class="pct-bar-wrap">
                    <div class="pct-bar" :style="{ width: porcentaje(item[1]) + '%' }"></div>
                  </div>
                  {{ porcentaje(item[1]) }}%
                </div>
              </td>
              <td class="text-end">
                <span :class="badgeVsPromedio(item[1])">
                  {{ deltaPromedio(item[1]) }}
                </span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary fw-bold">
              <td>Total ({{ filasFiltradas.length }} médicos{{ busqueda ? ' filtrados' : '' }})</td>
              <td class="text-end">{{ totalAtenciones }}</td>
              <td class="text-end">100%</td>
              <td></td>
            </tr>
          </tfoot>
        </table>

        <div class="d-flex justify-content-between align-items-center">
          <small class="text-muted">
            Mostrando {{ rangoDesde }}–{{ rangoHasta }} de {{ filasFiltradas.length }} registros
          </small>
          <nav>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" :class="{ disabled: paginaActual === 1 }">
                <button class="page-link" @click="paginaActual--">‹</button>
              </li>
              <li
                v-for="p in paginasVisibles" :key="p"
                class="page-item"
                :class="{ active: p === paginaActual, disabled: p === '…' }"
              >
                <button class="page-link" @click="p !== '…' && (paginaActual = p)">{{ p }}</button>
              </li>
              <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
                <button class="page-link" @click="paginaActual++">›</button>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <!-- ── GRÁFICO ── -->
      <div v-if="vistaActiva === 'grafico'" class="mt-3">
        <div class="d-flex align-items-center gap-2 mb-3">
          <small class="text-muted">Mostrar top</small>
          <select class="form-select form-select-sm" style="width:75px" v-model="topN">
            <option :value="10">10</option>
            <option :value="15">15</option>
            <option :value="20">20</option>
            <option :value="9999">Todos</option>
          </select>
          <small class="text-muted">médicos con más atenciones</small>
        </div>
        <apexchart
          type="bar"
          :options="chartOptions"
          :series="chartSeries"
          :height="chartHeight"
        />
      </div>

    </div>

    <div v-else-if="consultado" class="alert alert-info mt-3">
      No hay datos para el período seleccionado.
    </div>
    <Footer />
  </div>
</template>

<script>
import Layout        from '@/components/Layout.vue'
import Footer        from '@/components/Footer.vue'
import VueApexCharts from 'vue3-apexcharts'
import api           from '@/services/api'
import {
  getToday, getThisWeek, getThisMonth,
  getThisQuarter, getThisSemester, getThisYear,
} from '@/modules/queryDateUtils.js'

export default {
  name: 'ReporteAtencionesPorMedico',
  components: { Layout, Footer, apexchart: VueApexCharts },
  data() {
    return {
      fechaDesde:          '',
      fechaHasta:          '',
      atencionesPorMedico: [],
      vistaActiva:         'tabla',
      cargando:            false,
      consultado:          false,
      // tabla
      busqueda:       '',
      filasPorPagina: 25,
      paginaActual:   1,
      sortKey:        'atenciones',
      sortDir:        'desc',
      // gráfico
      topN: 10,
      atajos: [
        { key: 'hoy',       label: 'Hoy',             clase: 'btn-outline-primary',   fn: getToday        },
        { key: 'semana',    label: 'Semana actual',    clase: 'btn-outline-danger',    fn: getThisWeek     },
        { key: 'mes',       label: 'Mes actual',       clase: 'btn-outline-secondary', fn: getThisMonth    },
        { key: 'trimestre', label: 'Trimestre actual', clase: 'btn-outline-success',   fn: getThisQuarter  },
        { key: 'semestre',  label: 'Semestre actual',  clase: 'btn-outline-info',      fn: getThisSemester },
        { key: 'anio',      label: 'Año actual',       clase: 'btn-outline-warning',   fn: getThisYear     },
      ],
    }
  },
  computed: {
    totalAtenciones() {
      return this.atencionesPorMedico.reduce((s, i) => s + i[1], 0)
    },
    promedioAtenciones() {
      if (!this.atencionesPorMedico.length) return 0
      return (this.totalAtenciones / this.atencionesPorMedico.length).toFixed(1)
    },
    medicoTop() {
      if (!this.atencionesPorMedico.length) return '—'
      return [...this.atencionesPorMedico].sort((a, b) => b[1] - a[1])[0][0]
    },
    maxAtenciones() {
      if (!this.atencionesPorMedico.length) return 0
      return Math.max(...this.atencionesPorMedico.map(i => i[1]))
    },

    // ── Tabla ──
    filasFiltradas() {
      const q = this.busqueda.toLowerCase().trim()
      const base = q
        ? this.atencionesPorMedico.filter(i => i[0].toLowerCase().includes(q))
        : [...this.atencionesPorMedico]
      base.sort((a, b) => {
        const av = this.sortKey === 'nombre' ? a[0] : a[1]
        const bv = this.sortKey === 'nombre' ? b[0] : b[1]
        if (av < bv) return this.sortDir === 'asc' ? -1 : 1
        if (av > bv) return this.sortDir === 'asc' ? 1 : -1
        return 0
      })
      return base
    },
    totalPaginas() {
      return Math.max(1, Math.ceil(this.filasFiltradas.length / this.filasPorPagina))
    },
    rangoDesde() {
      return this.filasFiltradas.length ? (this.paginaActual - 1) * this.filasPorPagina + 1 : 0
    },
    rangoHasta() {
      return Math.min(this.paginaActual * this.filasPorPagina, this.filasFiltradas.length)
    },
    filasPagina() {
      return this.filasFiltradas.slice(this.rangoDesde - 1, this.rangoHasta)
    },
    paginasVisibles() {
      const total = this.totalPaginas
      const cur   = this.paginaActual
      if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
      const pages = [1]
      if (cur > 3) pages.push('…')
      for (let p = Math.max(2, cur - 1); p <= Math.min(total - 1, cur + 1); p++) pages.push(p)
      if (cur < total - 2) pages.push('…')
      pages.push(total)
      return pages
    },

    // ── Gráfico ──
    datosGrafico() {
      return [...this.atencionesPorMedico]
        .sort((a, b) => b[1] - a[1])
        .slice(0, this.topN)
    },
    chartHeight() {
      return Math.max(350, this.datosGrafico.length * 40)
    },
    chartOptions() {
      const promedio = parseFloat(this.promedioAtenciones)
      return {
        chart: { toolbar: { show: false }, fontFamily: 'inherit' },
        plotOptions: { bar: { horizontal: true, borderRadius: 3 } },
        colors: ['#0d6efd'],
        dataLabels: {
          enabled: true,
          formatter: v => v.toLocaleString(),
          style: { fontSize: '11px' },
        },
        xaxis: { title: { text: 'Número de atenciones' } },
        // Línea de referencia en el promedio
        annotations: {
          xaxis: [{
            x:           promedio,
            borderColor: '#fd7e14',
            strokeDashArray: 4,
            label: {
              text:  `Promedio: ${promedio}`,
              style: { color: '#fff', background: '#fd7e14', fontSize: '11px' },
            },
          }],
        },
        tooltip: {
          y: { formatter: (v, { dataPointIndex }) => {
            const pct = this.porcentaje(this.datosGrafico[dataPointIndex][1])
            return `${v.toLocaleString()} atenciones (${pct}%)`
          }},
        },
        grid: { borderColor: '#e9ecef' },
      }
    },
    chartSeries() {
      return [{
        name: 'Atenciones',
        data: this.datosGrafico.map(i => ({ x: i[0], y: i[1] })),
      }]
    },
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods: {
    aplicarAtajo(atajo) {
      const { fechaDesde, fechaHasta } = atajo.fn()
      this.fechaDesde = fechaDesde
      this.fechaHasta = fechaHasta
      this.generarReporte()
    },
async generarReporte() {
  if (!this.fechaDesde || !this.fechaHasta) return
  this.cargando     = true
  this.consultado   = false
  this.busqueda     = ''
  this.paginaActual = 1
  try {
    const idEmpresa = window.sessionStorage.getItem('idEmpresa')
    const { data }  = await api.get('/vwatencions/por-fecha', {
      params: { idEmpresa, fechaDesde: this.fechaDesde, fechaHasta: this.fechaHasta },
    })

    const mapa = {}
    for (const ate of (data ?? [])) {
      const medico = ate.nombreMedico ?? 'SIN MÉDICO'
      mapa[medico] = (mapa[medico] ?? 0) + 1
    }

    this.atencionesPorMedico = Object.entries(mapa)
      .map(([nombre, count]) => [nombre, count])
      .sort((a, b) => b[1] - a[1])

  } catch (error) {
    console.error('Error al obtener los datos:', error)
    this.atencionesPorMedico = []
  } finally {
    this.cargando   = false
    this.consultado = true
  }
},
    ordenar(key) {
      if (this.sortKey === key) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
        this.sortDir = key === 'atenciones' ? 'desc' : 'asc'
      }
      this.paginaActual = 1
    },
    porcentaje(valor) {
      if (!this.totalAtenciones) return 0
      return ((valor / this.totalAtenciones) * 100).toFixed(1)
    },
    // Columna "vs. promedio" — badge coloreado
    deltaPromedio(valor) {
      const diff = valor - parseFloat(this.promedioAtenciones)
      const sign = diff > 0 ? '+' : ''
      return `${sign}${diff.toFixed(0)}`
    },
    badgeVsPromedio(valor) {
      const diff = valor - parseFloat(this.promedioAtenciones)
      if (Math.abs(diff) < parseFloat(this.promedioAtenciones) * 0.1)
        return 'badge bg-secondary'          // dentro del ±10%: gris
      return diff > 0 ? 'badge bg-danger' : 'badge bg-success'
    },
    exportToCSV() {
      const filas = [
        ['Médico', 'Número de Atenciones', '%', 'vs. Promedio'],
        ...this.atencionesPorMedico.map(item => [
          item[0],
          item[1],
          `${this.porcentaje(item[1])}%`,
          this.deltaPromedio(item[1]),
        ]),
        ['Total', this.totalAtenciones, '100%', ''],
      ]
      const csv  = filas.map(f => f.join(';')).join('\n')
      const blob = new Blob([csv], { type: 'text/csv' })
      const url  = URL.createObjectURL(blob)
      const a    = Object.assign(document.createElement('a'), {
        href: url, download: 'Reporte_Atenciones_Por_Medico.csv',
      })
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
  },
}
</script>

<style scoped>
.kpi-card {
  background: #f8f9fa; border: 1px solid #dee2e6;
  border-radius: 8px; padding: 14px 18px; text-align: center;
}
.kpi-label {
  font-size: 0.75rem; color: #6c757d;
  text-transform: uppercase; letter-spacing: .04em; margin-bottom: 4px;
}
.kpi-value      { font-size: 1.6rem; font-weight: 700; color: #0d6efd; line-height: 1.1; }
.kpi-value--sm  { font-size: 0.95rem; font-weight: 600; }
.kpi-sub        { font-size: 0.8rem; color: #6c757d; margin-top: 2px; }

.tabs { display: flex; gap: 4px; border-bottom: 2px solid #dee2e6; }
.tablink {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 18px; border: none;
  border-bottom: 3px solid transparent; margin-bottom: -2px;
  background: transparent; color: #6c757d;
  font-size: 0.875rem; font-weight: 500; cursor: pointer;
  border-radius: 6px 6px 0 0; transition: all 0.2s ease;
}
.tablink:hover { color: #0d6efd; background: #f0f4ff; }
.active-tab    { color: #0d6efd; border-bottom-color: #0d6efd; background: #fff; font-weight: 600; }

.sortable       { cursor: pointer; user-select: none; white-space: nowrap; }
.sortable:hover { background: #495057; }
.sort-icon      { font-size: 14px; vertical-align: middle; opacity: .7; }

.pct-bar-wrap { width: 60px; height: 6px; background: #e9ecef; border-radius: 3px; overflow: hidden; }
.pct-bar      { height: 100%; background: #0d6efd; border-radius: 3px; transition: width 0.4s ease; }
</style>